var _rect, _rect2, _circle, _line, _circle2, _line2, _circle3, _line3, _circle4, _line4, _circle5, _line5, _circle6, _line6, _circle7, _line7, _circle8, _line8, _circle9, _line9, _circle0, _line0, _line1, _circle1, _line10, _circle10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoPlatform5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.8,
    y: 14.8,
    width: 18.4,
    height: 18.4,
    rx: 3.2,
    stroke: "#FA6700",
    strokeWidth: 1.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.8,
    y: 18.8,
    width: 10.4,
    height: 10.4,
    rx: 1.2,
    stroke: "#FA6700",
    strokeWidth: 1.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 24,
    r: 2,
    transform: "rotate(90 39 24)",
    stroke: "#FA6700",
    strokeWidth: 1.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 37,
    y1: 23.8,
    x2: 33,
    y2: 23.8,
    stroke: "#FA6700",
    strokeWidth: 1.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 31,
    r: 2,
    transform: "rotate(90 39 31)",
    stroke: "#FA6700",
    strokeWidth: 1.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 37,
    y1: 30.8,
    x2: 33,
    y2: 30.8,
    stroke: "#FA6700",
    strokeWidth: 1.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 17,
    r: 2,
    transform: "rotate(90 39 17)",
    stroke: "#FA6700",
    strokeWidth: 1.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 37,
    y1: 16.8,
    x2: 33,
    y2: 16.8,
    stroke: "#FA6700",
    strokeWidth: 1.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 7 22)",
    stroke: "#FA6700",
    strokeWidth: 1.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -0.8,
    x2: 4,
    y2: -0.8,
    transform: "matrix(1 0 0 -1 11 23)",
    stroke: "#FA6700",
    strokeWidth: 1.6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 7 29)",
    stroke: "#FA6700",
    strokeWidth: 1.6
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -0.8,
    x2: 4,
    y2: -0.8,
    transform: "matrix(1 0 0 -1 11 30)",
    stroke: "#FA6700",
    strokeWidth: 1.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 7 15)",
    stroke: "#FA6700",
    strokeWidth: 1.6
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -0.8,
    x2: 4,
    y2: -0.8,
    transform: "matrix(1 0 0 -1 11 16)",
    stroke: "#FA6700",
    strokeWidth: 1.6
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 39,
    r: 2,
    transform: "rotate(-180 24 39)",
    stroke: "#FA6700",
    strokeWidth: 1.6
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 24.2,
    y1: 37,
    x2: 24.2,
    y2: 33,
    stroke: "#FA6700",
    strokeWidth: 1.6
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 39,
    r: 2,
    transform: "rotate(-180 17 39)",
    stroke: "#FA6700",
    strokeWidth: 1.6
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 17.2,
    y1: 37,
    x2: 17.2,
    y2: 33,
    stroke: "#FA6700",
    strokeWidth: 1.6
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 39,
    r: 2,
    transform: "rotate(-180 31 39)",
    stroke: "#FA6700",
    strokeWidth: 1.6
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 31.2,
    y1: 37,
    x2: 31.2,
    y2: 33,
    stroke: "#FA6700",
    strokeWidth: 1.6
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 26 7)",
    stroke: "#FA6700",
    strokeWidth: 1.6
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    y1: -0.8,
    x2: 4,
    y2: -0.8,
    transform: "matrix(-4.37125e-08 1 1 4.37125e-08 25 11)",
    stroke: "#FA6700",
    strokeWidth: 1.6
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    y1: -0.8,
    x2: 4,
    y2: -0.8,
    transform: "matrix(-4.37125e-08 1 1 4.37125e-08 18 11)",
    stroke: "#FA6700",
    strokeWidth: 1.6
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 33 7)",
    stroke: "#FA6700",
    strokeWidth: 1.6
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    y1: -0.8,
    x2: 4,
    y2: -0.8,
    transform: "matrix(-4.37125e-08 1 1 4.37125e-08 32 11)",
    stroke: "#FA6700",
    strokeWidth: 1.6
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 19 7)",
    stroke: "#FA6700",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPlatform5);
export default __webpack_public_path__ + "static/media/ico_platform_5.b3772e6fe4df666f135bfcef464efe2b.svg";
export { ForwardRef as ReactComponent };